/** The language configuration. */
const config = {
    /**
     * The supported languages per feature. Note: When adding new languages make
     * sure the language is also present in the list of languages.
     */
    supportedLanguages: {
        conversation: [
            'af',
            'ar',
            'bg',
            'bn',
            // 'ca',
            'cs',
            'cy',
            'da',
            'de',
            'el',
            'en',
            'es',
            'et',
            'fa',
            'fi',
            'fr',
            'gu',
            'he',
            'hi',
            'hr',
            'hu',
            'id',
            'it',
            'ja',
            'kn',
            'ko',
            'lt',
            'lv',
            'mk',
            'ml',
            'mr',
            'ne',
            'nl',
            'no',
            'pa',
            'pl',
            'pt',
            'ro',
            'ru',
            'sk',
            'sl',
            'so',
            'sq',
            'sr',
            'sv',
            'sw',
            'ta',
            'te',
            'th',
            'tl',
            'tr',
            'uk',
            'ur',
            'vi',
            'zh',
        ],
        satisfaction: [
            'ar',
            'da',
            'de',
            'en',
            'es',
            'et',
            'fi',
            'fr',
            'is',
            'it',
            'ja',
            'ko',
            'lt',
            'lv',
            'nl',
            'no',
            'pl',
            'pt',
            'ru',
            'sv',
            'th',
            'tr',
            'zh',
        ],
    },
    /** The language configuration. */
    languages: {
        af: { code: 'af', name: 'Afrikaans' },
        ar: { code: 'ar', name: 'Arabic' },
        bg: { code: 'bg', name: 'Bulgarian' },
        bn: { code: 'bn', name: 'Bengali' },
        // ca: { code: 'ca', name: 'Catalan, Valencian' },
        cs: { code: 'cs', name: 'Czech' },
        cy: { code: 'cy', name: 'Welsh' },
        da: { code: 'da', name: 'Danish' },
        de: { code: 'de', name: 'German' },
        el: { code: 'el', name: 'Greek' },
        en: { code: 'en', name: 'English' },
        es: { code: 'es', name: 'Spanish' },
        et: { code: 'et', name: 'Estonian' },
        fa: { code: 'fa', name: 'Persian' },
        fi: { code: 'fi', name: 'Finnish' },
        fr: { code: 'fr', name: 'French' },
        gu: { code: 'gu', name: 'Gujarati' },
        he: { code: 'he', name: 'Hebrew' },
        hi: { code: 'hi', name: 'Hindi' },
        hr: { code: 'hr', name: 'Croatian' },
        hu: { code: 'hu', name: 'Hungarian' },
        id: { code: 'id', name: 'Indonesian' },
        is: { code: 'is', name: 'Icelandic' },
        it: { code: 'it', name: 'Italian' },
        ja: { code: 'ja', name: 'Japanese' },
        kn: { code: 'kn', name: 'Kannada' },
        ko: { code: 'ko', name: 'Korean' },
        lt: { code: 'lt', name: 'Lithuanian' },
        lv: { code: 'lv', name: 'Latvian' },
        mk: { code: 'mk', name: 'Macedonian' },
        ml: { code: 'ml', name: 'Malayalam' },
        mr: { code: 'mr', name: 'Marathi' },
        ne: { code: 'ne', name: 'Nepali' },
        nl: { code: 'nl', name: 'Dutch' },
        no: { code: 'no', name: 'Norwegian' },
        pa: { code: 'pa', name: 'Punjabi' },
        pl: { code: 'pl', name: 'Polish' },
        pt: { code: 'pt', name: 'Portuguese' },
        ro: { code: 'ro', name: 'Romanian' },
        ru: { code: 'ru', name: 'Russian' },
        sk: { code: 'sk', name: 'Slovak' },
        sl: { code: 'sl', name: 'Slovenian' },
        so: { code: 'so', name: 'Somali' },
        sq: { code: 'sq', name: 'Albanian' },
        sr: { code: 'sr', name: 'Serbian' },
        sv: { code: 'sv', name: 'Swedish' },
        sw: { code: 'sw', name: 'Swahili' },
        ta: { code: 'ta', name: 'Tamil' },
        te: { code: 'te', name: 'Telugu' },
        th: { code: 'th', name: 'Thai' },
        tl: { code: 'tl', name: 'Tagalog' },
        tr: { code: 'tr', name: 'Turkish' },
        uk: { code: 'uk', name: 'Ukrainian' },
        ur: { code: 'ur', name: 'Urdu' },
        vi: { code: 'vi', name: 'Vietnamese' },
        zh: { code: 'zh', name: 'Chinese' },
    },
};

const { supportedLanguages: { satisfaction, conversation }, languages, } = config;
/** The default conversation language code. */
const defaultConversationLanguageCode = 'en';
/** The default satisfaction language code. */
const defaultSatisfactionLanguageCode = 'en';
/** The conversation languages. */
const conversationLanguages = conversation
    .map((code) => languages[code])
    .sort((a, b) => {
    return a.name.localeCompare(b.name);
});
/** The satisfaction languages. */
const satisfactionLanguages = satisfaction
    .map((code) => languages[code])
    .sort((a, b) => {
    return a.name.localeCompare(b.name);
});

export { conversationLanguages, defaultConversationLanguageCode, defaultSatisfactionLanguageCode, satisfactionLanguages };
//# sourceMappingURL=index.es.js.map
